import {get} from 'utils/axios/cms/index'
import {
 IApiResponse,
 IHomePageCard,
 IHomePageQuickLink,
 IHomePageSupportingAppLink,
} from 'models/CMS'
import {AxiosError} from 'axios'
import {handleRejectedErrorMsg} from 'utils/helpers/handleError'
import qs from 'qs'

export const fetchHomePageCard = async (
 userCategoryKey: string,
 selectedLanguage?: string
) => {
 try {
  const query = qs.stringify(
   {
    filters: {
     $and: [
      {
       AccessLevel: {
        user_categories: {
         DehaatUserCategoryKey: {
          $eq: userCategoryKey,
         },
        },
       },
      },
     ],
    },
    populate: {
     Icon: true,
     BackgroundImage: true,
    },
    pagination: {
     page: 1,
     pageSize: 99999,
    },
    locale: selectedLanguage ?? 'en',
    sort: 'DisplayOrder, id',
    fields: ['*'],
   },
   {
    encodeValuesOnly: true, // prettify URL
   }
  )
  const res = await get<IApiResponse<IHomePageCard>>(
   `/home-page-cards?${query}`
  )
  if (res?.data) {
   return res.data
  }

  return null
 } catch (err: unknown) {
  const e = err as AxiosError
  handleRejectedErrorMsg(e)
  return []
 }
}

export const fetchHomePageQuickLinks = async (
 userCategoryKey: string,
 selectedLanguage?: string
) => {
 try {
  const query = qs.stringify(
   {
    filters: {
     $and: [
      {
       AccessLevel: {
        user_categories: {
         DehaatUserCategoryKey: {
          $eq: userCategoryKey,
         },
        },
       },
      },
     ],
    },
    populate: {
     Icon: true,
    },
    pagination: {
     page: 1,
     pageSize: 99999,
    },
    locale: selectedLanguage ?? 'en',
    sort: 'DisplayOrder, id',
    fields: ['*'],
   },
   {
    encodeValuesOnly: true, // prettify URL
   }
  )
  const res = await get<IApiResponse<IHomePageQuickLink>>(
   `/quick-links?${query}`
  )
  if (res?.data) {
   return res.data
  }

  return null
 } catch (err: unknown) {
  const e = err as AxiosError
  handleRejectedErrorMsg(e)
  return []
 }
}

export const fetchAupportingAppLinks = async (
 userCategoryKey: string,
 selectedLanguage?: string
) => {
 try {
  const query = qs.stringify(
   {
    filters: {
     $and: [
      {
       AccessLevel: {
        user_categories: {
         DehaatUserCategoryKey: {
          $eq: userCategoryKey,
         },
        },
       },
      },
     ],
    },
    populate: {
     QrCode: true,
     Icon: true,
     StoreIcon: true,
    },
    pagination: {
     page: 1,
     pageSize: 99999,
    },
    locale: selectedLanguage ?? 'en',
    sort: 'DisplayOrder, id',
    fields: ['*'],
   },
   {
    encodeValuesOnly: true, // prettify URL
   }
  )
  const res = await get<
   IApiResponse<IHomePageSupportingAppLink>
  >(`/supporting-app-links?${query}`)
  if (res?.data) {
   return res.data
  }

  return null
 } catch (err: unknown) {
  const e = err as AxiosError
  handleRejectedErrorMsg(e)
  return []
 }
}
